var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 4H9C6.239 4 4 6.239 4 9V23C4 25.761 6.239 28 9 28H23C25.762 28 28 25.761 28 23V9C28 6.239 25.762 4 23 4ZM12 23H9V12H12V23ZM10.5 10.732C9.534 10.732 8.75 9.942 8.75 8.968C8.75 7.994 9.534 7.204 10.5 7.204C11.466 7.204 12.25 7.994 12.25 8.968C12.25 9.942 11.467 10.732 10.5 10.732ZM24 23H21V17.396C21 14.028 17 14.283 17 17.396V23H14V12H17V13.765C18.396 11.179 24 10.988 24 16.241V23Z","fill":"#222222"}));
}

SocialLinkedin.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
